import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import './index.less';
import PageLayout from '../../Components/pageLayout';
import PDFPreviewModal from '../../Components/PdfViewModal'




function extractPublishTime(content?: string): string {
    if (!content) return '';
    const text = content.replace(/<[^>]+>/g, ' ');
    const m = text.match(/(?:发表时间|发布时间)\s*[:：]\s*([0-9]{4}[-/.年]\s*[0-9]{1,2}[-/.月]\s*[0-9]{1,2}(?:\s*[日]?\s*\d{1,2}:\d{2})?)/);
    return m?.[1]?.replace(/\s+/g, ' ').trim() || '';
}

const ArticleDetail: React.FC = () => {
    const history = useHistory();
    const { dataId, articleId } = useParams<{ dataId: string; articleId: string }>();

    // 动态引入对应的 JSON 文件
    let dataFile: any[] = [];
    try {
        dataFile = require(`../../data/data${dataId}.json`);
    } catch (e) {
        dataFile = [];
    }

    const article = Array.isArray(dataFile)
        ? dataFile.find((item: any) => item.id === Number(articleId))
        : null;

    const publishTime = extractPublishTime(article?.content);
    const isPdf = Boolean(article?.ispdf);
    return (
        <PageLayout history={history} children={[]} Content={
            <div className='article-detail page-container'>
                <div className='article-topbar'>
                    <button className='back-btn' onClick={() => history.goBack()}>返回上一页</button>
                </div>

                {!article && (
                    <div className='article-empty'>
                        <h2>未找到该内容</h2>
                        <p>可能链接已失效，或该内容已被调整。</p>
                        <button className='back-btn' onClick={() => history.push('/')}>返回首页</button>
                    </div>
                )}

                {article && (
                    <>
                        <header className='article-header'>
                            <h1 className='article-title'>{article.title || '文章详情'}</h1>
                            <div className='article-meta'>
                                <span>栏目编号：{dataId}</span>
                                {publishTime && <span>发布时间：{publishTime}</span>}
                            </div>
                        </header>

                        {isPdf && (
                            <div className='content-container pdf-container'>
                                <p className='pdf-tip'>当前内容为 PDF 文档，可在下方直接浏览。</p>
                                <PDFPreviewModal
                                    fileName={article.title}
                                    fileUrl={'/' + article.url}
                                    onCancel={() => { }}
                                />
                            </div>
                        )}

                        {!isPdf && (
                            <article
                                className='content-container article-rich'
                                dangerouslySetInnerHTML={{ __html: article?.content || '' }}
                            />
                        )}
                    </>
                )}
            </div>
        } />
    );
};

export default ArticleDetail;